import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadStateService {
  private allUploadsCompletedSubject = new Subject<void>();
  allUploadsCompleted$ = this.allUploadsCompletedSubject.asObservable();

  constructor() {}

  notifyUploadsComplete(): void {
    this.allUploadsCompletedSubject.next();
  }
}
